function birthdayValidator() {
    const regexBirthday = /^([0-2][0-9]|(3)[0-1])[\/\-\.](((0)[0-9])|((1)[0-2]))[\/\-\.]\d{4}$/i;

    const directive = {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attr, ngModel) {
            ngModel.$validators['birthday-validator'] = function (birthday) {
                return regexBirthday.test(birthday);
            }
        }
    };
    return directive;
}

export default birthdayValidator;
